import { render, staticRenderFns } from "./rich-text-field.vue?vue&type=template&id=4ae344a4&"
import script from "./rich-text-field.vue?vue&type=script&lang=js&"
export * from "./rich-text-field.vue?vue&type=script&lang=js&"
import style0 from "./rich-text-field.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
